const unescape = (string: string) => JSON.parse(`"${string}"`);

export default unescape;
